import request from '@/utils/request'

const URL = 'http://migrationinsect.cn:5002';
// const URL = 'http://localhost:5002';
export function add(data) {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}

export function getWeatherData(location,type,duration) {
  return request({
    url: URL+'/Temp/'+location+'/'+type+'/'+duration,
    // url: 'http://localhost:5001/Temp/1/60',
    method: 'get',
    responseType: 'json'
  })
}
export function getWeatherDataNew(location,type,duration,startdate) {
  return request({
    url: URL+'/Temp/'+location+'/'+type+'/'+duration+'/'+startdate,
    // url: 'http://localhost:5001/Temp/1/60',
    method: 'get',
    responseType: 'json'
  })
}
export function getData(location,fawData,duration) {
  return request({
    url: URL+'/Predict/'+location+'/'+fawData+'/'+duration,
    // url: 'http://migrationinsect.cn:5001/Predict/'+location+'/'+fawData+'/'+duration,
    // url: 'http://localhost:5001/Predict/'+location+'/'+fawData+'/'+duration,
    method: 'get',
    responseType: 'json'
  })
}
// export function getDataNew(location,fawData,duration,startdate,paramtype,foodtype) {
//   return request({
//     url: URL+'/Predict/'+location+'/'+fawData+'/'+duration+'/'+startdate+'/'+paramtype+'/'+foodtype,
//     // url: 'http://migrationinsect.cn:5001/Predict/'+location+'/'+fawData+'/'+duration,
//     // url: 'http://localhost:5001/Predict/'+location+'/'+fawData+'/'+duration,
//     method: 'get',
//     responseType: 'json'
//   })
// }
export function getDataNew(location,fawData,duration,startdate,paramtype,foodtype,totaltype,datatype) {
  return request({
    url: URL+'/Predict/'+location+'/'+fawData+'/'+duration+'/'+startdate+'/'+paramtype+'/'+foodtype+'/'+totaltype+'/'+datatype,
    // url: 'http://migrationinsect.cn:5001/Predict/'+location+'/'+fawData+'/'+duration,
    // url: 'http://localhost:5001/Predict/'+location+'/'+fawData+'/'+duration,
    method: 'get',
    responseType: 'json'
  })
}
export function getUserLocation(lng, lat) {
  return request({
    // url: 'http://migrationinsect.cn:5001/Temp/1/60',
    url: URL+'/getLocation/'+ lng+'/'+lat,
    method: 'get',
    responseType: 'json'
  })
}

export function DateTimeFormatter(fmt){
    // let time = new Date(fmt);
    // let y = time.getFullYear();
    // let m = time.getMonth() + 1;
    // let d = time.getDate();
  let d = new Date(fmt);
  let ye = d.getFullYear();
  let mo = (d.getMonth()+1).toString().padStart(2,'0');
  let da = d.getDate().toString().padStart(2,'0');
  // return y+'-'+m+'-'+d
  return ye+'-'+mo+'-'+da
  }

//
// export function getRadarData() {
//   return request({
//     url: 'http://121.36.19.108:6001/radarData',
//     method: 'get',
//     responseType: 'json'
//   })
// }

